/* eslint-disable react/jsx-props-no-spreading */

import {
  Tooltip as MuiTooltip,
  TooltipProps as MuiTooltipProps,
} from '@mui/material';

interface TooltipProps extends MuiTooltipProps {
  disabled?: boolean
}

function Tooltip(props: TooltipProps) {
  const {
    title, children, disabled = false, arrow, placement, ...restProps
  } = props;

  if (disabled) {
    return children;
  }

  return (
    <MuiTooltip
      disableInteractive
      leaveTouchDelay={0}
      title={title}
      arrow={arrow}
      placement={placement}
      {...restProps}
    >
      {children}
    </MuiTooltip>
  );
}

export default Tooltip;
